export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
  NONE = "NONE",
}

export type SortType = {
  index: number;
  direction: SortDirection;
};

export interface SortedData {
  data: Array<Record<string, unknown>>;
  sorting: SortType;
}

export type ColumnType = {
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customSorting?: ({
    a,
    b,
    direction,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    a: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b: any;
    direction: SortDirection;
  }) => number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render?: (data: any) => JSX.Element;
  isSortable?: boolean;
  alignment?: "flex-start" | "flex-end" | "baseline" | "initial" | "inherit";
  justification?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "initial"
    | "inherit";
};
